@if (changeNoticeTitle(); as title) {
  <div class="realtime-banner realtime-banner--saved" role="status" aria-live="polite">
    <div class="banner-icon">
      <i class="pi pi-refresh"></i>
    </div>
    <div class="banner-content">
      <div class="banner-title">{{ title }}</div>
      <div class="banner-description">
        @if (hasUnsavedChanges()) {
          Você ainda tem alterações não salvas. Se salvar agora, sobrescreve o que foi gravado; use
          Recarregar para ver a versão salva (as suas alterações serão perdidas).
        } @else {
          A tela ainda mostra a versão anterior. Use Recarregar para ver o que foi salvo.
        }
      </div>
    </div>
    <div class="banner-actions">
      <app-button
        [label]="'Recarregar'"
        [icon]="'pi pi-refresh'"
        [size]="'small'"
        (sendButtonClick)="onReload()">
      </app-button>
      <app-button
        [label]="'Dispensar'"
        [theme]="'white'"
        [size]="'small'"
        (sendButtonClick)="dismissChangeNotice()">
      </app-button>
    </div>
  </div>
}

@if (presenceText(); as text) {
  <div
    class="presence-strip"
    [class.presence-strip--editing]="someoneEditing()"
    role="status"
    aria-live="polite">
    <i class="pi" [class.pi-pencil]="someoneEditing()" [class.pi-users]="!someoneEditing()"></i>
    <span>{{ text }}</span>
  </div>
}
